import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NewQuizAnalysis;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import generateStyle from './styles';
import t from '@instructure/quiz-i18n/format-message';
import ExpandButton from '../../../../../common/components/shared/ExpandButton';
import { jsx } from '@instructure/emotion';
import generateComponentTheme from './theme';
import { formatTimeToFullNumeric } from '../../../../../common/util/formatTimespan';
import Card from '../../../../../common/components/shared/Card';
import AnalysisPopoverMetric from '../AnalysisPopoverMetric';
import AnalysisMetric from '../AnalysisMetric';
import { ScoreDistribution } from '../charts/ScoreDistribution/presenter';
import { quizAnalysisPropType } from '../../common/propTypes';
import PropTypes from 'prop-types';
import { Spinner } from '@instructure/ui-spinner';
import { cronbachsAlpha, standardDeviation } from './popoverContent';
import { withStyleOverrides } from '@instructure/quiz-common';
export var NewQuizAnalysis = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NewQuizAnalysis = /*#__PURE__*/function (_Component) {
  function NewQuizAnalysis() {
    var _this2;
    _classCallCheck(this, NewQuizAnalysis);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, NewQuizAnalysis, [].concat(args));
    _defineProperty(_this2, "state", {
      expanded: false
    });
    _defineProperty(_this2, "handleToggle", function () {
      _this2.setState({
        expanded: !_this2.state.expanded
      });
    });
    _defineProperty(_this2, "renderExpanded", function () {
      var scores = _this2.props.quizAnalysis.scores;
      return jsx("div", {
        css: _this2.props.styles.container
      }, jsx("div", {
        css: _this2.props.styles.metricGroup
      }, jsx(AnalysisPopoverMetric, {
        metricKey: "stddev",
        value: scores === null || scores === void 0 ? void 0 : scores.stddev,
        label: t('Standard Deviation'),
        popoverDescription: standardDeviation
      }), jsx(AnalysisPopoverMetric, {
        metricKey: "cronbachs_alpha",
        value: scores === null || scores === void 0 ? void 0 : scores.cronbachs_alpha,
        label: t("Cronbach's Alpha"),
        popoverDescription: cronbachsAlpha
      })));
    });
    _defineProperty(_this2, "renderContent", function () {
      var quizAnalysis = _this2.props.quizAnalysis;
      var scores = quizAnalysis.scores,
        attempts = quizAnalysis.attempts;
      var expanded = _this2.state.expanded;
      return jsx(Card, {
        css: _this2.props.styles.cardWrapper
      }, jsx("div", {
        css: _this2.props.styles.metricGroup
      }, jsx("div", {
        css: _this2.props.styles.metricsWrapper
      }, jsx(AnalysisMetric, {
        metricKey: "highscore",
        label: t('High Score'),
        value: scores === null || scores === void 0 ? void 0 : scores.max_percentage,
        suffix: "%"
      }), jsx(AnalysisMetric, {
        metricKey: "lowscore",
        label: t('Low Score'),
        value: scores === null || scores === void 0 ? void 0 : scores.min_percentage,
        suffix: "%"
      }), jsx(AnalysisMetric, {
        metricKey: "meanscore",
        label: t('Mean Score'),
        value: scores === null || scores === void 0 ? void 0 : scores.mean_percentage,
        suffix: "%"
      })), jsx("div", {
        css: _this2.props.styles.metricsWrapper
      }, jsx(AnalysisMetric, {
        metricKey: "median_percentage",
        label: t('Median Score'),
        value: scores === null || scores === void 0 ? void 0 : scores.median_percentage,
        suffix: "%"
      }), jsx(AnalysisMetric, {
        metricKey: "mean_elapsed_sec",
        label: t('Mean Elapsed Time'),
        value: formatTimeToFullNumeric(attempts === null || attempts === void 0 ? void 0 : attempts.mean_elapsed_sec)
      })), jsx("div", {
        css: _this2.props.styles.expandButtonContainer
      }, jsx(ExpandButton, {
        onClick: _this2.handleToggle,
        title: expanded ? t('collapse quiz analysis') : t('expand quiz analysis'),
        isExpanded: expanded
      }))), expanded && _this2.renderExpanded(), jsx(ScoreDistribution, {
        decileDistribution: _this2.getPreparedDecileDistribution()
      }));
    });
    return _this2;
  }
  _inherits(NewQuizAnalysis, _Component);
  return _createClass(NewQuizAnalysis, [{
    key: "getPreparedDecileDistribution",
    value: function getPreparedDecileDistribution() {
      var quizAnalysis = this.props.quizAnalysis;
      var scores = quizAnalysis.scores,
        metadata = quizAnalysis.metadata;
      var decileDistribution = _toConsumableArray((scores === null || scores === void 0 ? void 0 : scores.decile_distribution) || []);
      if (metadata.decile_distribution && (metadata.decile_distribution.high_extreme_values_count > 0 || metadata.decile_distribution.low_extreme_values_count > 0)) {
        var _metadata$decile_dist, _metadata$decile_dist2;
        decileDistribution.unshift((_metadata$decile_dist = metadata.decile_distribution) === null || _metadata$decile_dist === void 0 ? void 0 : _metadata$decile_dist.low_extreme_values_count);
        decileDistribution.push((_metadata$decile_dist2 = metadata.decile_distribution) === null || _metadata$decile_dist2 === void 0 ? void 0 : _metadata$decile_dist2.high_extreme_values_count);
      }
      return decileDistribution;
    }
  }, {
    key: "render",
    value: function render() {
      var fetchInProgress = this.props.fetchInProgress;
      if (fetchInProgress) {
        return jsx(Card, {
          css: this.props.styles.skeletonCardWrapper
        }, jsx(Spinner, {
          renderTitle: t('Loading quiz analysis data')
        }));
      } else {
        return this.renderContent();
      }
    }
  }]);
}(Component), _defineProperty(_NewQuizAnalysis, "displayName", 'NewQuizAnalysis'), _defineProperty(_NewQuizAnalysis, "componentId", "Quizzes".concat(_NewQuizAnalysis.displayName)), _defineProperty(_NewQuizAnalysis, "propTypes", {
  quizAnalysis: quizAnalysisPropType,
  fetchInProgress: PropTypes.bool,
  styles: PropTypes.object
}.isRequired), _defineProperty(_NewQuizAnalysis, "defaultProps", {
  quizAnalysis: {}
}), _NewQuizAnalysis)) || _class);